const StudentSettings = () => {

  return (
    <div className=" h-full w-full bg-green-200">

    </div>
  );
};

export default StudentSettings;